import { windowEditTimeTrackId } from '../../../../../../../config/constants.js';
import windowEditTimeTrack from '../../windowEditTimeTrack/windowEditTimeTrack.js';

export default () => {
    webix.ui(windowEditTimeTrack({}));
    $$(windowEditTimeTrackId).show();
};
